<template>
  <div :class="['card w-full pb-2', height, background]">
    <div class="card-body p-3">
      <div class="flex flex-row">
        <div class="flex-1">
          <h3 v-if="title" class="card-title text-lg">{{ title }}</h3>
        </div>
        <slot name="actions" />
      </div>
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: { type: String, default: '' },
    labelPosition: { type: String, default: 'top' },
    labelWidth: { type: String },
    height: { type: String },
    background: { type: String, default: 'bg-base-200' }
  },
  provide () {
    return {
      labelWidth: this.labelWidth,
      labelPosition: this.labelPosition
    }
  }
}
</script>
